/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ColorInputs */

const en_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const es_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const fr_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur`)
};

const de_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

const ja_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カラー`)
};

const zh_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色`)
};

const ar_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللون`)
};

const id_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warna`)
};

const it_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore`)
};

const ru_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет`)
};

const pt_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor`)
};

const ko_field_color = /** @type {(inputs: Field_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`색상`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Field_ColorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_color = /** @type {((inputs?: Field_ColorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ColorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_color(inputs)
	if (locale === "es") return es_field_color(inputs)
	if (locale === "fr") return fr_field_color(inputs)
	if (locale === "de") return de_field_color(inputs)
	if (locale === "ja") return ja_field_color(inputs)
	if (locale === "zh") return zh_field_color(inputs)
	if (locale === "ar") return ar_field_color(inputs)
	if (locale === "id") return id_field_color(inputs)
	if (locale === "it") return it_field_color(inputs)
	if (locale === "ru") return ru_field_color(inputs)
	if (locale === "pt") return pt_field_color(inputs)
	return ko_field_color(inputs)
});